import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'react-tooltip'
import '../partners.css'



const PartnersList = ({partnerList, updateStatus, getPartnerById}) => {

    const navigate = useNavigate();

    // const handleDealsAssociated = (id, name) => {
    //     console.log(id, name)
    //     const supplypartner = {
    //         name: name,
    //         id: id
    //       };
          
    //       // Convert the object to a JSON string and store it in sessionStorage
    //       sessionStorage.setItem("sp", JSON.stringify(supplypartner));
    //     navigate(`/deals/${name}`);
    // }
    const handleDealsAssociated = (id, name) => {
        // navigate('/deals', { state: { id, name } });
    };
    
    
   
    return (
        <>
        <div className="table-responsive custom-table">
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th >sr. no </th>
                        <th>Logo</th>
                        <th className='deal-name'>Name <i className="fas fa-sort"></i></th>
                        <th className='email'>Email <i className="fas fa-sort"></i></th>
                        <th>Currency</th>
                        <th>Sequence</th>
                        <th className='status'>Status </th>
                        <th className='action'>Action </th>
                    </tr>
                </thead>
                
                <tbody>
                    {partnerList && partnerList.length > 0 ? (
                        partnerList.map((item, i) => {  
                              
                return <tr key={i}>
                            <td>{i+1}</td>
                            <td className='text-center'><img src={item?.logo_path} /> </td>
                            <td className="wrap-string deal-name">{item?.name}</td>
                            <td className='email' >{item?.email}</td>
                            <td className='text-center'>{item?.currency}</td>
                            <td className='text-center'>{item?.partner_sequence}</td>
                            <td className='text-center status'>
                                <label className="custom-switch">
                                    <input type="checkbox" checked={item?.status === 1} onClick={() => updateStatus(item?.id, item.status === 1 ? 0 : 1)}/>
                                    <span className="slider round"></span>
                                </label>
                            </td>
                            
                            <td className='text-center action'> 
                                <div className="table-icons">
                                    <a data-tooltip-id="my-tooltip-inline" data-tooltip-content="Edit User Detail" data-tooltip-place="top">
                                    <i className="fa-regular fa-pen-to-square green" onClick={() => getPartnerById(item?.id)} ></i></a>
                                    <a data-tooltip-id="my-tooltip-inline" data-tooltip-content="Deals's Count" data-tooltip-place="top">
                                        <span className="deal-count" onClick={() => handleDealsAssociated(item.id, item.name)}> {item?.totalDeal}</span>
                                    </a>
                                </div>
                            </td>
                        </tr>
                    })
                    ): (
                        <tr>
                            <td colSpan={6} className='text-center'>no data </td>
                        </tr>
                    )}
                        
                </tbody>
            </table>
        </div>

        <Tooltip id="my-tooltip-inline" place="top" className="custom-tooltip" />
        </>
    );
};

export default PartnersList;


